import { LoginForm } from "../features/auth/LoginForm";

export function LoginRoute() {
  return (
    <div className="mx-auto max-w-md px-4 py-12">
      <LoginForm />
    </div>
  );
}
